export function CalculatorInputSummary(props: {
  header: string;
  fields: Array<{ label: string; value: string | number }>;
}) {
  const { header, fields } = props;

  return (
    <div className="flex-col py-8 pl-9 shrink-0 min-w-80 flex">
      <span className="text-lg font-semibold">{header}</span>
      <div className="h-px my-6 bg-border/50" />
      <span className="text-sm font-semibold">Calculations are based on:</span>
      <div className="space-y-6 flex flex-col mt-6">
        {fields.map((f) => (
          <div
            key={f.label}
            className="flex items-center gap-4 justify-between text-sm"
          >
            <span>{f.label}</span>
            <span className="font-semibold">{f.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
